import { HttpClient } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import {FormBuilder, Validators, FormGroup, ReactiveFormsModule} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Dimension } from '../../models/dimension.model';
import { environment } from '../../environments/environment';
import { CommonModule } from '@angular/common';
import { MatStepper, MatStep } from "@angular/material/stepper";
import { MatRadioGroup, MatRadioButton } from "@angular/material/radio";
import { MatIcon } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatStepperModule } from '@angular/material/stepper';
import { TranslateModule, TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-view-questionnaire',
  standalone: true,
  imports: [CommonModule, MatStepper, MatStep, MatRadioGroup, MatRadioButton, MatIcon, ReactiveFormsModule, MatButtonModule, MatStepperModule, TranslateModule],
  templateUrl: './view-questionnaire.component.html',
  styleUrl: './view-questionnaire.component.css'
})
export class ViewQuestionnaireComponent implements OnInit {

  questionnaire: any;
  isLinear = false;
  returnUrl: string = '/';
  title: string = '';
  subtitle: string = '';
  authorName: string = '';
  dateCompilation: string = '';
  totalScore?: number;
  dimensions: Dimension[] = [];
  dimensionForms: FormGroup[] = [];

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private fb: FormBuilder,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit() {
  const questionnaireId = this.route.snapshot.paramMap.get('questionnaireId'); // corrisponde alla route
  console.log(questionnaireId);

  if (questionnaireId) {
    const token = localStorage.getItem('token');
    console.log(token);

    const headers = { Authorization: `Bearer ${token}` };
    this.http.get<any>(`${environment.apiUrl}/api/questionnaires/view/${questionnaireId}`, { headers })
      .subscribe(res => {
        console.log("sono dentro");
        this.questionnaire = res;
        this.totalScore = res.totalScore;
        console.log(this.questionnaire);
        console.log(this.totalScore);

        this.initStepper();
      }, err => {
        console.error("Errore durante il fetch del questionario:", err);
      });
  }


     this.route.queryParams.subscribe(params => {
      if (params['returnUrl']) {
        this.returnUrl = params['returnUrl'];
      }
      /* if(params['title']){
        this.title = params['title'];
      }
      if(params['subtitle']){
        this.subtitle = params['subtitle'];
      }
      if(params['authorName']){
        this.authorName = params['authorName'];
      } */

    const state = history.state;
      if (state) {
        this.title = state.title || '';
        this.subtitle = state.subtitle || '';
        this.authorName = state.authorName || '';
        this.dateCompilation = state.dateCompilation || '';
      }

    });

    this.route.queryParams.subscribe(params => {
      if (params['returnUrl']) {
        this.returnUrl = params['returnUrl'];
      }
      console.log("Return URL:", this.returnUrl);
    });

  }

  initStepper() {
    this.dimensionForms = [];
    this.dimensions = [];

    this.questionnaire.dimensions.forEach((dim: any) => {
      const group: { [key: string]: any } = {};

      dim.questions.forEach((question: any, index: number) => {
        group[`question${index + 1}`] = this.fb.control(
          { value: question.answerValue, disabled: true },
          Validators.required
        );
      });
      this.dimensionForms.push(this.fb.group(group));
      this.dimensions.push(dim); 
    });

    console.log(this.dimensions)

  }

  goBack() {
    this.router.navigate([this.returnUrl], 
                        { queryParams: { returnUrl: '/inclusion-index'},
                        state: {
                            title: this.translate.instant('inclusion-index.trainee-assessment-title'),
                            subtitle: this.translate.instant('inclusion-index.trainee-assessment-subtitle'),
                          }
      });
    
  }
}
